const BANNER_URL_PARAMS = '?fields=*,levels.levels_id.*,banners.*,banners.mobile.*,banners.desktop.*&filter[status][_eq]=published&filter[system][_eq]=quero-bolsa'

export const CAMPAIGN_CONFIG_URL = `/items/campaigns${BANNER_URL_PARAMS}`
